module.exports = global["$"] = require("-!/data/www/mathesio/html/webapp/node_modules/imports-loader/index.js?global=>window,this=>window!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?$!../~/imports-loader?global=>window,this=>window!../~/jquery/dist/jquery.js
// module id = 85
// module chunks = 1